import React from 'react'
import { DASHBOARD_CONTEXT } from '@trustero/trustero-api-web/lib/dashboard/dashboard_pb'
import { NONE_NAME } from 'src/Utils/globalConstants'
import { FilterName, FilterParam } from '../../FilterBar.types'
import { DashboardDimensionFilterDropdown } from './DashboardDimensionFilterDropdowns/DashboardDimensionFilterDropdown'

export const DashboardPolicyFilterDropdown = ({
  isNested = false,
  dashboardContext,
  dashboardName,
}: {
  isNested?: boolean
  dashboardContext?: DASHBOARD_CONTEXT
  dashboardName?: string
}): JSX.Element | null => {
  if (dashboardContext === undefined || dashboardName === undefined) {
    return null
  }

  return (
    <DashboardDimensionFilterDropdown
      isNested={isNested}
      filterParam={FilterParam.DASHBOARD_POLICY}
      filterName={FilterName.DASHBOARD_POLICY}
      dashboardContext={dashboardContext}
      dashboardName={dashboardName}
      dimension="policies"
      // Controls with no policy carry no policies dim; this is the bucket for them.
      undefinedString={NONE_NAME}
    />
  )
}
